import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 md:py-16 lg:py-20">
        <div className="grid md:grid-cols-3 gap-10 md:gap-12 lg:gap-16 mb-12 md:mb-16">
          {/* About Column */}
          <div>
            <Link to="/" className="inline-block mb-6 md:mb-8 group">
              <img 
                src="https://customer-assets.emergentagent.com/job_reshadi-replica/artifacts/2d3adpeg_imageedit_14_6586610433.png"
                alt="Reshadi Logo"
                className="h-14 md:h-16 lg:h-20 w-auto transition-transform duration-300 group-hover:scale-105"
                style={{ filter: 'brightness(0) saturate(100%) invert(70%) sepia(38%) saturate(536%) hue-rotate(120deg) brightness(95%) contrast(89%)' }}
              />
            </Link>
            <p className="text-white/70 leading-relaxed font-light text-sm md:text-base">
              A high-tech AI solutions projects company. Securing the future by bridging the gap between
              high-level policy and functional execution.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg md:text-xl font-normal mb-6 md:mb-8 text-[#3eb5a0]">Quick Links</h3>
            <ul className="space-y-3 md:space-y-4">
              <li>
                <a href="#home" className="text-white/70 hover:text-[#3eb5a0] transition-colors duration-300 font-light text-sm md:text-base">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/70 hover:text-[#3eb5a0] transition-colors duration-300 font-light text-sm md:text-base">
                  Services
                </a>
              </li>
              <li>
                <a href="#about" className="text-white/70 hover:text-[#3eb5a0] transition-colors duration-300 font-light text-sm md:text-base">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/70 hover:text-[#3eb5a0] transition-colors duration-300 font-light text-sm md:text-base">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg md:text-xl font-normal mb-6 md:mb-8 text-[#3eb5a0]">Address</h3>
            <ul className="space-y-4 md:space-y-5">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#3eb5a0] mt-1 flex-shrink-0" />
                <span className="text-white/70 font-light text-sm md:text-base leading-relaxed">
                  Road 6, Plot 75
                  <br />
                  Modder East Orchards
                  <br />
                  Delmas, 2211
                  <br />
                  Mpumalanga, South Africa
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 md:pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            <p className="text-white/60 text-xs md:text-sm font-light text-center md:text-left">
              © {currentYear} Reshadi Investment and Projects (Pty) Ltd. All rights reserved.
            </p>
            <div className="flex gap-6 md:gap-8">
              <a href="#" className="text-white/60 hover:text-[#3eb5a0] transition-colors duration-300 text-xs md:text-sm font-light">
                Privacy Policy
              </a>
              <a href="#" className="text-white/60 hover:text-[#3eb5a0] transition-colors duration-300 text-xs md:text-sm font-light">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;